import { createSelector } from '@reduxjs/toolkit';

import { specialPromosBlocksSelector } from './specialPromosBlocksSelector';

export const newbuildingsPlusBlocksPikSelector = createSelector(
  specialPromosBlocksSelector,
  state => state.newbuildingsPlusBlocksPik,
);
